// This product includes color specifications and designs developed by Cynthia Brewer (http://colorbrewer.org/).
// JavaScript specs as packaged in the D3 library (d3js.org). Please see license at http://colorbrewer.org/export/LICENSE.txt
export const colorbrewer = {
  BrBG_10: {
    1: ["#d8b365","#5ab4ac"],
    2: ["#d8b365","#5ab4ac"],
    3: ["#a6611a","#dfc27d","#80cdc1","#018571"],
    4: ["#a6611a","#dfc27d","#80cdc1","#018571"],
    5: ["#8c510a","#d8b365","#f6e8c3","#c7eae5","#5ab4ac","#01665e"],
    6: ["#8c510a","#d8b365","#f6e8c3","#c7eae5","#5ab4ac","#01665e"],
    7: ["#8c510a","#bf812d","#dfc27d","#f6e8c3","#c7eae5","#80cdc1","#35978f","#01665e"],
    8: ["#8c510a","#bf812d","#dfc27d","#f6e8c3","#c7eae5","#80cdc1","#35978f","#01665e"],
    9: ["#543005","#8c510a","#bf812d","#dfc27d","#f6e8c3","#c7eae5","#80cdc1","#35978f","#01665e","#003c30"],
    10: ["#543005","#8c510a","#bf812d","#dfc27d","#f6e8c3","#c7eae5","#80cdc1","#35978f","#01665e","#003c30"],
  },
  PuOr_10: {
    1: ["#f1a340","#998ec3"],
    2: ["#f1a340","#998ec3"],
    3: ["#e66101","#fdb863","#b2abd2","#5e3c99"],
    4: ["#e66101","#fdb863","#b2abd2","#5e3c99"],
    5: ["#b35806","#f1a340","#fee0b6","#d8daeb","#998ec3","#542788"],
    6: ["#b35806","#f1a340","#fee0b6","#d8daeb","#998ec3","#542788"],
    7: ["#b35806","#e08214","#fdb863","#fee0b6","#d8daeb","#b2abd2","#8073ac","#542788"],
    8: ["#b35806","#e08214","#fdb863","#fee0b6","#d8daeb","#b2abd2","#8073ac","#542788"],
    9: ["#7f3b08","#b35806","#e08214","#fdb863","#fee0b6","#d8daeb","#b2abd2","#8073ac","#542788","#2d004b"],
    10: ["#7f3b08","#b35806","#e08214","#fdb863","#fee0b6","#d8daeb","#b2abd2","#8073ac","#542788","#2d004b"],
  },  
  PRGn_10: {
    1: ["#af8dc3","#7fbf7b"],
    2: ["#af8dc3","#7fbf7b"],
    3: ["#7b3294","#c2a5cf","#a6dba0","#008837"],
    4: ["#7b3294","#c2a5cf","#a6dba0","#008837"],
    5: ["#762a83","#af8dc3","#e7d4e8","#d9f0d3","#7fbf7b","#1b7837"],
    6: ["#762a83","#af8dc3","#e7d4e8","#d9f0d3","#7fbf7b","#1b7837"],
    7: ["#762a83","#9970ab","#c2a5cf","#e7d4e8","#d9f0d3","#a6dba0","#5aae61","#1b7837"],
    8: ["#762a83","#9970ab","#c2a5cf","#e7d4e8","#d9f0d3","#a6dba0","#5aae61","#1b7837"],
    9: ["#40004b","#762a83","#9970ab","#c2a5cf","#e7d4e8","#d9f0d3","#a6dba0","#5aae61","#1b7837","#00441b"],
    10: ["#40004b","#762a83","#9970ab","#c2a5cf","#e7d4e8","#d9f0d3","#a6dba0","#5aae61","#1b7837","#00441b"],
  }, 
  PiYG_10: {
    1: ["#e9a3c9","#a1d76a"],
    2: ["#e9a3c9","#a1d76a"],
    3: ["#d01c8b","#f1b6da","#b8e186","#4dac26"],
    4: ["#d01c8b","#f1b6da","#b8e186","#4dac26"],
    5: ["#c51b7d","#e9a3c9","#fde0ef","#e6f5d0","#a1d76a","#4d9221"],
    6: ["#c51b7d","#e9a3c9","#fde0ef","#e6f5d0","#a1d76a","#4d9221"],
    7: ["#c51b7d","#de77ae","#f1b6da","#fde0ef","#e6f5d0","#b8e186","#7fbc41","#4d9221"],
    8: ["#c51b7d","#de77ae","#f1b6da","#fde0ef","#e6f5d0","#b8e186","#7fbc41","#4d9221"],
    9: ["#8e0152","#c51b7d","#de77ae","#f1b6da","#fde0ef","#e6f5d0","#b8e186","#7fbc41","#4d9221","#276419"],
    10: ["#8e0152","#c51b7d","#de77ae","#f1b6da","#fde0ef","#e6f5d0","#b8e186","#7fbc41","#4d9221","#276419"],
  },
  RdBu_10: {
    1: ["#ef8a62","#67a9cf"],
    2: ["#ef8a62","#67a9cf"],
    3: ["#ca0020","#f4a582","#92c5de","#0571b0"],
    4: ["#ca0020","#f4a582","#92c5de","#0571b0"],
    5: ["#b2182b","#ef8a62","#fddbc7","#d1e5f0","#67a9cf","#2166ac"],
    6: ["#b2182b","#ef8a62","#fddbc7","#d1e5f0","#67a9cf","#2166ac"],
    7: ["#b2182b","#d6604d","#f4a582","#fddbc7","#d1e5f0","#92c5de","#4393c3","#2166ac"],
    8: ["#b2182b","#d6604d","#f4a582","#fddbc7","#d1e5f0","#92c5de","#4393c3","#2166ac"],
    9: ["#67001f","#b2182b","#d6604d","#f4a582","#fddbc7","#d1e5f0","#92c5de","#4393c3","#2166ac","#053061"],
    10: ["#67001f","#b2182b","#d6604d","#f4a582","#fddbc7","#d1e5f0","#92c5de","#4393c3","#2166ac","#053061"],
  },
  RdGy_10: {
    1: ["#ef8a62","#999999"],
    2: ["#ef8a62","#999999"],
    3: ["#ca0020","#f4a582","#bababa","#404040"],
    4: ["#ca0020","#f4a582","#bababa","#404040"],
    5: ["#b2182b","#ef8a62","#fddbc7","#e0e0e0","#999999","#4d4d4d"],
    6: ["#b2182b","#ef8a62","#fddbc7","#e0e0e0","#999999","#4d4d4d"],
    7: ["#b2182b","#d6604d","#f4a582","#fddbc7","#e0e0e0","#bababa","#878787","#4d4d4d"],
    8: ["#b2182b","#d6604d","#f4a582","#fddbc7","#e0e0e0","#bababa","#878787","#4d4d4d"],
    9: ["#67001f","#b2182b","#d6604d","#f4a582","#fddbc7","#e0e0e0","#bababa","#878787","#4d4d4d","#1a1a1a"],
    10: ["#67001f","#b2182b","#d6604d","#f4a582","#fddbc7","#e0e0e0","#bababa","#878787","#4d4d4d","#1a1a1a"],
  },
  RdYlBu_10: {
    1: ["#fc8d59","#91bfdb"],
    2: ["#fc8d59","#91bfdb"],
    3: ["#d7191c","#fdae61","#abd9e9","#2c7bb6"],
    4: ["#d7191c","#fdae61","#abd9e9","#2c7bb6"],
    5: ["#d73027","#fc8d59","#fee090","#e0f3f8","#91bfdb","#4575b4"],
    6: ["#d73027","#fc8d59","#fee090","#e0f3f8","#91bfdb","#4575b4"],
    7: ["#d73027","#f46d43","#fdae61","#fee090","#e0f3f8","#abd9e9","#74add1","#4575b4"],
    8: ["#d73027","#f46d43","#fdae61","#fee090","#e0f3f8","#abd9e9","#74add1","#4575b4"],
    9: ["#a50026","#d73027","#f46d43","#fdae61","#fee090","#e0f3f8","#abd9e9","#74add1","#4575b4","#313695"],
    10: ["#a50026","#d73027","#f46d43","#fdae61","#fee090","#e0f3f8","#abd9e9","#74add1","#4575b4","#313695"],
  },
  Spectral_10: {
    1: ["#fc8d59","#99d594"],
    2: ["#fc8d59","#99d594"],
    3: ["#d7191c","#fdae61","#abdda4","#2b83ba"],
    4: ["#d7191c","#fdae61","#abdda4","#2b83ba"],
    5: ["#d53e4f","#fc8d59","#fee08b","#e6f598","#99d594","#3288bd"],
    6: ["#d53e4f","#fc8d59","#fee08b","#e6f598","#99d594","#3288bd"],
    7: ["#d53e4f","#f46d43","#fdae61","#fee08b","#e6f598","#abdda4","#66c2a5","#3288bd"],
    8: ["#d53e4f","#f46d43","#fdae61","#fee08b","#e6f598","#abdda4","#66c2a5","#3288bd"],
    9: ["#9e0142","#d53e4f","#f46d43","#fdae61","#fee08b","#e6f598","#abdda4","#66c2a5","#3288bd","#5e4fa2"],
    10: ["#9e0142","#d53e4f","#f46d43","#fdae61","#fee08b","#e6f598","#abdda4","#66c2a5","#3288bd","#5e4fa2"],
  },
  RdYlGn_10: {
    1: ["#fc8d59","#91cf60"],
    2: ["#fc8d59","#91cf60"],
    3: ["#d7191c","#fdae61","#a6d96a","#1a9641"],
    4: ["#d7191c","#fdae61","#a6d96a","#1a9641"],
    5: ["#d73027","#fc8d59","#fee08b","#d9ef8b","#91cf60","#1a9850"],
    6: ["#d73027","#fc8d59","#fee08b","#d9ef8b","#91cf60","#1a9850"],
    7: ["#d73027","#f46d43","#fdae61","#fee08b","#d9ef8b","#a6d96a","#66bd63","#1a9850"],
    8: ["#d73027","#f46d43","#fdae61","#fee08b","#d9ef8b","#a6d96a","#66bd63","#1a9850"],
    9: ["#a50026","#d73027","#f46d43","#fdae61","#fee08b","#d9ef8b","#a6d96a","#66bd63","#1a9850","#006837"],
    10: ["#a50026","#d73027","#f46d43","#fdae61","#fee08b","#d9ef8b","#a6d96a","#66bd63","#1a9850","#006837"],
  },
  Accent_8: {
    1: ["#7fc97f"],
    2: ["#7fc97f","#beaed4"],
    3: ["#7fc97f","#beaed4","#fdc086"],
    4: ["#7fc97f","#beaed4","#fdc086","#ffff99"],
    5: ["#7fc97f","#beaed4","#fdc086","#ffff99","#386cb0"],
    6: ["#7fc97f","#beaed4","#fdc086","#ffff99","#386cb0","#f0027f"],
    7: ["#7fc97f","#beaed4","#fdc086","#ffff99","#386cb0","#f0027f","#bf5b17"],
    8: ["#7fc97f","#beaed4","#fdc086","#ffff99","#386cb0","#f0027f","#bf5b17","#666666"]
  },
  Dark2_8: {
    1: ["#1b9e77"],
    2: ["#1b9e77","#d95f02"],
    3: ["#1b9e77","#d95f02","#7570b3"],
    4: ["#1b9e77","#d95f02","#7570b3","#e7298a"],
    5: ["#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e"],
    6: ["#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e","#e6ab02"],
    7: ["#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e","#e6ab02","#a6761d"],
    8: ["#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e","#e6ab02","#a6761d","#666666"]
  },
  Paired_12: {
    1: ["#a6cee3"],
    2: ["#a6cee3","#1f78b4"],
    3: ["#a6cee3","#1f78b4","#b2df8a"],
    4: ["#a6cee3","#1f78b4","#b2df8a","#33a02c"],
    5: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99"],
    6: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c"],
    7: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f"],
    8: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00"],
    9: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00","#cab2d6"],
    10: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00","#cab2d6","#6a3d9a"],
    11: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00","#cab2d6","#6a3d9a","#ffff99"],
    12: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00","#cab2d6","#6a3d9a","#ffff99","#b15928"]
  },
  Pastel1_9: {
    1: ["#fbb4ae"],
    2: ["#fbb4ae","#b3cde3"],
    3: ["#fbb4ae","#b3cde3","#ccebc5"],
    4: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4"],
    5: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4","#fed9a6"],
    6: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4","#fed9a6","#ffffcc"],
    7: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4","#fed9a6","#ffffcc","#e5d8bd"],
    8: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4","#fed9a6","#ffffcc","#e5d8bd","#fddaec"],
    9: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4","#fed9a6","#ffffcc","#e5d8bd","#fddaec","#f2f2f2"]
  },
  Pastel2_8: {
    1: ["#b3e2cd"],
    2: ["#b3e2cd","#fdcdac"],
    3: ["#b3e2cd","#fdcdac","#cbd5e8"],
    4: ["#b3e2cd","#fdcdac","#cbd5e8","#f4cae4"],
    5: ["#b3e2cd","#fdcdac","#cbd5e8","#f4cae4","#e6f5c9"],
    6: ["#b3e2cd","#fdcdac","#cbd5e8","#f4cae4","#e6f5c9","#fff2ae"],
    7: ["#b3e2cd","#fdcdac","#cbd5e8","#f4cae4","#e6f5c9","#fff2ae","#f1e2cc"],
    8: ["#b3e2cd","#fdcdac","#cbd5e8","#f4cae4","#e6f5c9","#fff2ae","#f1e2cc","#cccccc"]
  },
  Set1_9: {
    1: ["#e41a1c"],
    2: ["#e41a1c","#377eb8"],
    3: ["#e41a1c","#377eb8","#4daf4a"],
    4: ["#e41a1c","#377eb8","#4daf4a","#984ea3"],
    5: ["#e41a1c","#377eb8","#4daf4a","#984ea3","#ff7f00"],
    6: ["#e41a1c","#377eb8","#4daf4a","#984ea3","#ff7f00","#ffff33"],
    7: ["#e41a1c","#377eb8","#4daf4a","#984ea3","#ff7f00","#ffff33","#a65628"],
    8: ["#e41a1c","#377eb8","#4daf4a","#984ea3","#ff7f00","#ffff33","#a65628","#f781bf"],
    9: ["#e41a1c","#377eb8","#4daf4a","#984ea3","#ff7f00","#ffff33","#a65628","#f781bf","#999999"]
  },
  Set2_8: {
    1: ["#66c2a5"],
    2: ["#66c2a5","#fc8d62"],
    3: ["#66c2a5","#fc8d62","#8da0cb"],
    4: ["#66c2a5","#fc8d62","#8da0cb","#e78ac3"],
    5: ["#66c2a5","#fc8d62","#8da0cb","#e78ac3","#a6d854"],
    6: ["#66c2a5","#fc8d62","#8da0cb","#e78ac3","#a6d854","#ffd92f"],
    7: ["#66c2a5","#fc8d62","#8da0cb","#e78ac3","#a6d854","#ffd92f","#e5c494"],
    8: ["#66c2a5","#fc8d62","#8da0cb","#e78ac3","#a6d854","#ffd92f","#e5c494","#b3b3b3"]
  },
  Set3_12: {
    1: ["#8dd3c7"],
    2: ["#8dd3c7","#ffffb3"],
    3: ["#8dd3c7","#ffffb3","#bebada"],
    4: ["#8dd3c7","#ffffb3","#bebada","#fb8072"],
    5: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3"],
    6: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462"],
    7: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69"],
    8: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5"],
    9: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5","#d9d9d9"],
    10: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5","#d9d9d9","#bc80bd"],
    11: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5","#d9d9d9","#bc80bd","#ccebc5"],
    12: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5","#d9d9d9","#bc80bd","#ccebc5","#ffed6f"]
  },
};